import { render } from "./FoundView.vue?vue&type=template&id=3ddc394f&scoped=true"
import script from "./FoundView.vue?vue&type=script&lang=js"
export * from "./FoundView.vue?vue&type=script&lang=js"

import "./FoundView.vue?vue&type=style&index=0&id=3ddc394f&lang=scss&scoped=true"

import exportComponent from "/Users/matt/Dev/convict-memorial-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ddc394f"]])

export default __exports__